import { Modal, Spin } from "antd"
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"

import WithdrawForm from "../../../../Components/Forms/WithdrawForm"
import Creators from "../../reducer"

export const WithdrowalModal = ({ modalType, setModalType }) => {
  const dispatch = useDispatch()

  const { t } = useTranslation()
  const { saveFetching } = useSelector((state) => state.users)
  const isMobile = useSelector((state) => state.nav.isMobile)

  const handleCloseModal = () => {
    setModalType(false)
  }

  const handleSubmitForm = (data) => {
    dispatch(Creators.withdrawRequest({ balance: modalType?.balance_id, ...data }))
  }

  return (
    <Modal
      open={modalType?.type === "withdraw"}
      centered={!isMobile}
      width={410}
      title={t("Funds withdrawal")}
      footer={null}
      closable="true"
      onCancel={handleCloseModal}
      destroyOnClose
      classNames={{ content: "clear-bg" }}
      getContainer={() => document.getElementById("global-wrap")}
    >
      <Spin size="large" spinning={saveFetching || false}>
        <WithdrawForm onSubmit={handleSubmitForm} onClose={handleCloseModal} />
      </Spin>
    </Modal>
  )
}
